import React, { useState } from 'react';
import { Modal, Form, Button, Alert } from 'react-bootstrap';
import axios from 'axios';

function InvitePlayerModal({ show, handleClose, league, season }) {
    const [emails, setEmails] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        setSuccess(false);

        // Split emails by comma or newline and trim whitespace
        const emailList = emails
            .split(/[,\n]/)
            .map(email => email.trim())
            .filter(email => email.length > 0);

        if (emailList.length === 0) {
            setError('Please enter at least one email address');
            setLoading(false);
            return;
        }

        try {
            const response = await axios.post(
                `/api/leagues/send-league-invite/${season.id}/`,
                { emails: emailList },
                { withCredentials: true }
            );

            if (response.data.success) {
                setSuccess(true);
                setEmails('');
            } else {
                setError(response.data.error || 'Failed to send invites');
            }
        } catch (err) {
            setError(err.response?.data?.error || 'Failed to send invites');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Invite Players to {league?.name}</Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    {error && <Alert variant="danger">{error}</Alert>}
                    {success && <Alert variant="success">Invites sent successfully!</Alert>}

                    <Form.Group controlId="emails">
                        <Form.Label>Email Addresses</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={5}
                            value={emails}
                            onChange={(e) => setEmails(e.target.value)}
                            placeholder="Enter email addresses (one per line or comma-separated)"
                            required
                        />
                        <Form.Text className="text-muted">
                            Enter multiple email addresses separated by commas or new lines
                        </Form.Text>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button variant="primary" type="submit" disabled={loading}>
                        {loading ? 'Sending...' : 'Send Invites'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default InvitePlayerModal; 